// extracted by mini-css-extract-plugin
module.exports = {"ad-wrapper":"organism1-m__ad-wrapper__39vgR","load-more-view":"organism1-m__load-more-view__2MBE1","en-load-more-view":"organism1-m__en-load-more-view__2fREw"};